import { Button, Empty, Spin, Tag } from "antd";
import { PlusOutlined, TeamOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { CreateGroupDrawer } from "../components/CreateGroupDrawer";
import { listGroups } from "../api/groups";
import type { GroupSummary } from "../api/groups";
import { relativeTime } from "../utils/time";

export function GroupsPage() {
  const [groups, setGroups] = useState<GroupSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const refresh = () => {
    setLoading(true);
    listGroups()
      .then((d) => setGroups(d.groups))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <>
      <PageHeader
        title="群组"
        subtitle="按业务线归纳重要联系人,批量发送 + 状态追踪 + 一键跟进。"
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>
            新建群组
          </Button>
        }
      />
      <div style={{ padding: 16, maxWidth: 880, margin: "0 auto" }}>
        {loading && groups.length === 0 ? (
          <div style={{ padding: 32, display: "grid", placeItems: "center" }}>
            <Spin />
          </div>
        ) : groups.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <span style={{ color: "var(--ant-color-text-secondary)" }}>
                <TeamOutlined /> 还没有群组,创建一个开始批量发送
              </span>
            }
          >
            <Button type="primary" icon={<PlusOutlined />} onClick={() => setOpen(true)}>
              新建群组
            </Button>
          </Empty>
        ) : (
          <ul style={{ listStyle: "none", margin: 0, padding: 0, display: "grid", gap: 12, gridTemplateColumns: "minmax(0, 1fr)" }}>
            {groups.map((g) => (
              <li key={g.id}>
                <button
                  type="button"
                  onClick={() => navigate(`/groups/${g.id}`)}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: 16,
                    padding: 16,
                    background: "var(--ant-color-bg-container)",
                    border: "1px solid var(--ant-color-border)",
                    borderRadius: 12,
                    cursor: "pointer",
                    textAlign: "left",
                    color: "inherit",
                  }}
                >
                  <div
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      background: "color-mix(in srgb, var(--ant-color-primary) 14%, transparent)",
                      color: "var(--ant-color-primary)",
                      display: "grid",
                      placeItems: "center",
                      fontSize: 24,
                      flexShrink: 0,
                    }}
                  >
                    <TeamOutlined />
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 600, fontSize: 17 }}>{g.name}</div>
                    <div
                      style={{
                        fontSize: 14,
                        color: "var(--ant-color-text-secondary)",
                        marginTop: 2,
                      }}
                    >
                      {g.memberCount} 人 · {g.campaignCount} 次发送 · 创建于{" "}
                      {relativeTime(g.createdAt)}
                    </div>
                  </div>
                  <Tag>查看</Tag>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <CreateGroupDrawer
        open={open}
        onClose={() => setOpen(false)}
        onCreated={(id) => {
          refresh();
          navigate(`/groups/${id}`);
        }}
      />
    </>
  );
}
